import { isHappa, paymentsEnabled } from '@/constants'

import { useAuthRoles } from './use-auth-roles'

/**
 * User IDs allowed to use payments on Happa even when NEXT_PUBLIC_PAYMENTS_ENABLED is 'false'.
 * Requested as a manual override for testing/support purposes.
 */
const PAYMENTS_OVERRIDE_USER_IDS = [505182]

export const usePaymentsEnabled = () => {
  const { user } = useAuthRoles()

  if (paymentsEnabled) return true

  return isHappa && !!user && PAYMENTS_OVERRIDE_USER_IDS.includes(user.id)
}
